export enum GlobalStoreActions {
    updateConfirmationInsurance = 'updateConfirmationInsurance',
    resetConfirmationInsurance = 'resetConfirmationInsurance',
    changeConfirmationInsuranceSearchValue = 'changeConfirmationInsuranceSearchValue',
    changeUserManagementSearchValue = 'changeUserManagementSearchValue',
    selectUser = 'selectUser',
    changeUsersListPage = 'changeUsersListPage',
    changeUsersListRowsPerPage = 'changeUsersListRowsPerPage',
}
